import browserPageLoadTimeline from 'images/browser_diagram_page-load-timeline.webp';
import browserPageLoadChart from 'images/browser_screenshot-full_page-load-chart.webp';
import * as React from 'react';
export default {
  browserPageLoadTimeline,
  browserPageLoadChart,
  React
};